module.exports = "/images/myOrdersImgDesktop.svg";